import {createContext, type ReactNode, use} from 'react'

type SetVisibleField = (identifier: string, visible: boolean) => void

const VisibleFieldIdentifiersContext = createContext<ReadonlySet<string> | null>(null)
const SetVisibleFieldContext = createContext<SetVisibleField | null>(null)

/**
 * Exposes an already-owned selection and setter to visibility hooks without owning another
 * draft. `SavedViewConfigurationProvider` owns the selection and plugs it in here.
 */
export function VisibleFieldsContextProvider({
  identifiers,
  setVisible,
  children,
}: {
  identifiers: ReadonlySet<string>
  setVisible: SetVisibleField
  children: ReactNode
}) {
  return (
    <SetVisibleFieldContext value={setVisible}>
      <VisibleFieldIdentifiersContext value={identifiers}>{children}</VisibleFieldIdentifiersContext>
    </SetVisibleFieldContext>
  )
}

export function useVisibleFieldIdentifiers() {
  const value = use(VisibleFieldIdentifiersContext)
  if (value === null) throw new Error('useVisibleFieldIdentifiers must be used within <VisibleFieldsContextProvider>')
  return value
}

export function useSetVisibleField() {
  const value = use(SetVisibleFieldContext)
  if (value === null) throw new Error('useSetVisibleField must be used within <VisibleFieldsContextProvider>')
  return value
}
